// extracted by mini-css-extract-plugin
export default {"videoInfoText":"nSor18","root":"W6Z2Zz","descriptionText":"zhchdc","rolesTitle":"O_9SLY","role":"hHpYxW","roleName":"fF63dl","large":"pnPyd6","normal":"xulEn5","small":"fxMyPf"};